import {ACTION_CODE} from './_actionCode';
import {ReferenceService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DELETE_REFERENCE';

export async function deleteReference(userData: Record<string, string>, id: string) {
    try {
        LoggerService.logInfo('Action - deleteReference - Start');

        const deleteReferenceResult = await ReferenceService.deleteReference(userData, id);

        LoggerService.logInfo('Action - deleteReference - End - Success');

        return ResultModel.newSuccessResult(deleteReferenceResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - deleteReference - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
